export enum CoOwnerInputLabel {
  FirstName = 'Non-Borrowing Co-Owner First Name',
  LastName = 'Non-Borrowing Co-Owner Last Name',
  MiddleName = 'Non-Borrowing Co-Owner Middle Name',
  Address = 'Address',
  City = 'City',
  State = 'State',
  Zip = 'Zip Code',
  Email = 'Non-Borrowing Co-Owner Email',
  PhoneNumber = 'Non-Borrowing Co-Owner Cell Phone',
  Last4Ssn = 'Non-Borrowing Co-Owner SSN (Last 4 Digits Only)',
}

export enum CoOwnerInputName {
  FirstName = 'firstName',
  LastName = 'lastName',
  MiddleName = 'middleName',
  Address = 'address',
  City = 'city',
  State = 'state',
  Zip = 'zip',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  DateOfBirth = 'dateOfBirth',
  Last4Ssn = 'ssn',
}
